import { render, staticRenderFns } from "./createEnum.vue?vue&type=template&id=6f68384d"
import script from "./createEnum.vue?vue&type=script&lang=js"
export * from "./createEnum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports